import { render } from "./CreateRegions.vue?vue&type=template&id=2b4759f6"
import script from "./CreateRegions.vue?vue&type=script&lang=js"
export * from "./CreateRegions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__